export default __webpack_public_path__ + "static/media/city-population-less.57f6c378.svg";